import { FilterType as FilterOperator } from "types/enums";

export type FilterLogicalOperator = "and" | "or";

export interface FilterRange {
    min: unknown;
    max: unknown;
}

export interface FilterLogicalNode {
    op: FilterLogicalOperator;
    left: FilterNode;
    right: FilterNode;
}

export interface FilterLeafNode {
    op: FilterOperator;
    left: unknown;
    right?: unknown | FilterRange;
    message?: string;
}

/**
 * Filter tree stored by BE in `cascades.filter` / `offers.filter`.
 * The generated `App.Data.*.filter` is typed as `Array<any> | null`, but BE actually expects a single root node.
 */
export type FilterNode = FilterLogicalNode | FilterLeafNode;

/** Replaces generated `filter: Array<any> | null` with the real tree type. */
export type WithFilterTree<T extends { filter?: unknown }> = Omit<T, "filter"> &
    (undefined extends T["filter"] ? { filter?: FilterNode | null } : { filter: FilterNode | null });

export const isFilterLogicalNode = (node: FilterNode): node is FilterLogicalNode => node.op === "and" || node.op === "or";

/** Generated request/response types declare `filter` as `Array<any> | null`, but BE stores a single root node. */
export const asRequestFilter = (tree: FilterNode | null): Array<unknown> | null => tree as unknown as Array<unknown> | null;
